import axios from "axios";
import Cookies from 'js-cookie';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  timeout: 8000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});




axiosInstance.interceptors.request.use((config) => {
  // Get the JWT token from the cookie
  const token = Cookies.get('JWT');

  // If the token exists, add it to the Authorization header
  if (token) {
    config.headers['Authorization'] = 'JWT ' + token;
  }

  return config;
}, (error) => {
  // If there's an error, reject the Promise with the error
  return Promise.reject(error);
});




export async function login(email, password) {
  const body = JSON.stringify({ email, password });
  try {
    const res = await axiosInstance.post("/auth/jwt/create/", body);
    if (res.status === 200) {
      saveTokens(res.data.access, res.data.refresh);
    }
    return res;
  } catch (err) {
    return err.response;
  }
}

export async function logout() {
  Cookies.remove('JWT');
  Cookies.remove('JWT_refresh');
}

export async function verifyToken() {
  const token = Cookies.get('JWT');
  const body = JSON.stringify({ token });
  try {
    const res = await axiosInstance.post("/auth/jwt/verify/", body);
    return res;
  } catch(err){
    console.log()
    return err.response;
  }
}

export async function refreshTokens() {
  const refresh = Cookies.get('JWT_refresh');
  const body = JSON.stringify({ refresh });
  try {
    const res = await axiosInstance.post("/auth/jwt/refresh/", body);
    if (res.status === 200) {
      saveTokens(res.data.access, refresh);
    }
    return res;
  } catch (err) {
    return err.response;
  }
}

async function saveTokens(token, refresh_token) {
  Cookies.set('JWT', token);
  Cookies.set('JWT_refresh', refresh_token);
}


export async function getStuff(path){
  //const token = Cookies.get('JWT');
  try{
    const res = await axiosInstance.get(path);
    return res;
  }catch(err){
    console.log("GET STUFF ERROR", err.response, "path", path)
    return err.response;
  }
}


export async function postStuff(path, body){
  try{
    const res = await axiosInstance.post(path, body);
    return res;
  }catch(err){
    console.log("POST STUFF ERROR", err.response, "path", path)
    return err.response;
  }
}


export async function downloadExportRequest(path, body){
  console.log(path);
    const res = await axiosInstance.get(path);
    return res;
}

// function DownloadExport(path, body,  fileName) {
//         res = DownloadExportRequest(path, body)
//         const aElement = document.createElement('a');
//         aElement.setAttribute('download', fileName);
//         const href = URL.createObjectURL(blob);
//         aElement.href = href;
//         aElement.setAttribute('target', '_blank');
//         aElement.click();
//         URL.revokeObjectURL(href);
      
  

//   #downloadFile('http://localhost:8000/api/export/clients/', 'out.xlsx');
// }